import React, { Fragment, useContext, useRef, useState } from 'react'
import { Alert } from 'react-bootstrap';

import useTxSender from '../../hooks/useTxSender.js';
import useLog from "../../hooks/useLog.js"

import { Loader } from '../../components/Loader.js';
import { UserContext } from "../../Contexts/UserContext/UserContext.js";
import { Row } from "../../components/Row";
import { Spaces } from "../../components/Spaces";
import { TextDisplay } from "../../components/TextDisplay/TextDisplay";
import SuccessTxSender from '../../components/SuccessTxSender.js';
import { default_func_jsx_fail, FaInfoCircle } from '../../helpers/helpers.js';
import { AlertRevokeAutoConvert, AlertRevokeCheckAddress } from './Slide_AllRevoke.js';
import { confirmPopupHard } from '../../components/confirmPopup.js';
import RowWithTitle from '../../components/RowWithTitle.js';
import Bold from '../../components/Bold.js';



export default function Slide_Backup(props) {
	const userContext = useContext(UserContext)
	const log = useLog("Slide_Backup: ")

	// --- VARS ---

	const coinprops = userContext.get_selected_coin_props()
	const tokenID = coinprops.tokenid
	const tokenName = coinprops.name

	const tokenActionID = tokenID + "_backup"
	const mess_default = "" //"Un récapitulatif des "+tokenName+" à minter va s'afficher ici"

	// state & refs
	const ref_messageEndRef = useRef(null) // for autoscroll
	const [new_token_contract, set_new_token_contract] = useState("")

	const array_bool_user_inputs = [
		Boolean(new_token_contract && new_token_contract.length > 0)
	]

	const token_balance = userContext.tokens_balance[tokenID]
	const bool_context_has_loaded = (token_balance != null) // && (context.bsvprice !=null)

	// --- FUNCTIONS ---

	async function func_empty_fields() {
		set_new_token_contract("")
	}

	var jsx_loading = null //<LoaderWithMess mess={mess_default} />
	var jsx_recap = null

	const jsx_sending = <Fragment>
		Backup du contrat en cours... &nbsp;
		<i className="reloadIcon fas fa-sync fa-spin" />
	</Fragment>

	const func_jsx_success = (txstate) => {
		return (
			<SuccessTxSender txstate={txstate}>
				Backup du contrat effectué avec succès !
			</SuccessTxSender>
		)
	}

	// --- HOOK useTxSender ---

	const [
		bool_broadcast_lock,
		func_resetMess,
		dict_sendbutton_style,
		jsx_mess,
	]
		= useTxSender(
			tokenActionID,
			array_bool_user_inputs,
			bool_context_has_loaded,
			ref_messageEndRef,
			mess_default,
			jsx_loading,
			jsx_recap,
			jsx_sending,
			func_jsx_success,
			default_func_jsx_fail,
			func_empty_fields,
		)

	// --- FUNCTIONS ---

	function handleChange_new_token_contract(event) {
		var val = event.target.value
		val = val.toString()

		log("new_token_contractt=", val)
		set_new_token_contract(val)
	}


	const handleClick = async (event) => {
		event.preventDefault() // prevent redirection

		// don't allow parallel sends
		if (bool_broadcast_lock) {
			window.alert("Echec: une demande est déjà en cours d'envoi.")
			return
		}

		const confirm_message = "⚠️ IRREVERSIBLE, ETES VOUS CERTAIN DE VOULOIR BACKUP LE CONTRAT ? ⚠️"
		const confirmed = await confirmPopupHard(confirm_message)
		if (!confirmed) return // abort

		// async but we don't want to await here !
		userContext.revokerContract_backup(new_token_contract)
	}

	// --- DISPLAY ---

	log("\n new_token_contract=", new_token_contract,
		"\n bool_broadcast_lock=", bool_broadcast_lock,)


	const revokerJig = userContext.revokerJig
	const revoker_owner = revokerJig ? revokerJig.owner : null
	const wallet_owner = userContext.address_owner
	const isRevokerOwner = revoker_owner === wallet_owner

	return (
		<div>

			<h1><i className="fas fa-shield-alt" /><Spaces count="3" />
				Backup
			</h1><br />

			{isRevokerOwner ? null : <>
				<Alert variant="danger">
					<Bold>Vous ne semblez pas être l'administrateur de ce token.</Bold>
				</Alert><br />
			</>}

			<Alert variant="light">
				<FaInfoCircle />
				Le Backup répond au cas de perte des clés privées du contrat de Token.
				Il permet de passer sur un nouveau contrat avec conversion automatique des coins,
				et en gardant les même mintuples et blacklist.
			</Alert>

			<AlertRevokeAutoConvert />

			<AlertRevokeCheckAddress />
			<br />

			<RowWithTitle title={<Fragment>
				Adresse du nouveau contract TokkenR
			</Fragment>}>
				<input style={{ marginBottom: "0px" }} onChange={handleChange_new_token_contract}
					value={new_token_contract}
					placeholder="Entrez l'adresse d'un nouveau contract TokkenR"
					type='text' className='item' />
			</RowWithTitle>

			<center>
				<div ref={ref_messageEndRef}>
					{jsx_mess ?
						<Row><TextDisplay>
							{jsx_mess}
						</TextDisplay></Row>
						: null}
				</div>
			</center>

			<Row>
				<button style={dict_sendbutton_style} onClick={handleClick}
					id='submit_button' className="submitbutton">
					BACKUP
				</button>
			</Row>

		</div>
	)
}
